import qs from 'qs'
import { HTTP } from './helpers/http.js'

const DEFAULT_SEARCH_MAX_SIZE = 25
const defaultQueryParams = {
  limit: DEFAULT_SEARCH_MAX_SIZE,
}
const account = {
  login(account) {
    const url = '/api/v1/login'
    return HTTP.post(url, account)
  },

  loginWithAzure(azureToken) {
    const url = '/api/v1/auth/azure-active-directory'
    return HTTP.post(url, azureToken)
  },

  logout() {
    const url = '/api/v1/logout'
    const data = {
      device: 'browser',
    }
    return HTTP.post(url, data, {
      timeout: 1000,
    })
  },

  getMe() {
    const url = '/api/v1/me'
    return HTTP.get(url, {
      timeout: 5000,
    })
  },

  getAccountOrganizations() {
    const url = '/api/v1/accounts/organizations'
    return HTTP.get(url)
  },

  switchOrganization(organizationId) {
    const url = '/api/v1/accounts/organization-switch'
    return HTTP.post(url, { organizationId })
  },

  getById(organizationId, accountId) {
    const url = `/api/v1/organizations/${organizationId}/accounts/${accountId}`
    return HTTP.get(url)
  },

  create(organizationId, account) {
    const url = `/api/v1/organizations/${organizationId}/accounts`
    return HTTP.post(url, account)
  },

  register(account) {
    const url = '/api/v1/accounts/register'
    return HTTP.post(url, account)
  },

  update(organizationId, accountId, data) {
    const url = `/api/v1/organizations/${organizationId}/accounts/${accountId}`
    return HTTP.put(url, data)
  },

  delete(organizationId, accountId) {
    const url = `/api/v1/organizations/${organizationId}/accounts/${accountId}`
    return HTTP.delete(url)
  },

  getAccounts(organizationId, options = {}) {
    const queryParams = { ...defaultQueryParams, ...options }

    queryParams.relations = ['organization', 'site', 'photo']

    if (options.relations) {
      queryParams.relations = queryParams.relations.concat(options.relations)
    }

    if (options.filters) {
      queryParams.filters = options.filters
    }

    if (options.startAfter) {
      queryParams.startAfter = options.startAfter
    }

    if (options.startBefore) {
      queryParams.startBefore = options.startBefore
    }

    if (options.terms) {
      queryParams.sort = { by: '_score', order: 'desc' }
    }

    const params = {
      params: queryParams,
      paramsSerializer: function(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/stream/${organizationId}/accounts`
    return HTTP.get(url, params)
  },

  createResetPassword(email, token) {
    const url = '/api/v1/accounts/recover-password'
    return HTTP.post(url, { email: email, captchaToken: token })
  },

  getResetPasswordToken(token) {
    const url = `/api/v1/accounts/recover-password/${token}`
    return HTTP.get(url)
  },

  changePasswordWithToken(token, password) {
    const url = `/api/v1/accounts/change-password/${token}`
    return HTTP.post(url, { password: password })
  },

  changePassword(organizationId, accountId, payload) {
    const url = `/api/v1/organizations/${organizationId}/accounts/${accountId}/password`
    return HTTP.put(url, payload)
  },

  googleAuth(token) {
    const url = '/api/v1/auth/google'
    return HTTP.post(url, { token })
  },

  // this endpoint only achieves the necessities for the ProfileView
  // this doesn't follow the patterns for a restful api
  getProfile(organizationId, accountId) {
    const params = {
      accountId,
    }

    const url = `/api/v1/organizations/${organizationId}/computed/profile`
    return HTTP.get(url, {
      params,
      paramsSerializer: function(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    })
  },

  getAccountsByIds(organizationId, params) {
    const url = `api/v1/organizations/${organizationId}/accounts`
    return HTTP.get(url, {
      params,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    })
  },

  searchPeople(organizationId, params) {
    const url = `api/v1/stream/${organizationId}/people`
    return HTTP.get(url, {
      params,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    })
  },

  getAuthenticationTypes(email) {
    const url = '/api/v1/accounts/authentication-types'
    return HTTP.post(
      url,
      { email: email },
      { headers: { Authorization: null } }
    )
  },

  resetPassword(payload) {
    const url = `api/v1/organizations/${payload.organizationId}/accounts/${payload.userId}/reset`
    const password = payload.password
    return HTTP.put(url, {
      password,
      paramsSerializer(password) {
        return qs.stringify(password, { arrayFormat: 'brackets' })
      },
    })
  },

  prismaticAuth() {
    return HTTP.post('/api/v1/auth/prismatic')
  },
}

export default account
